import { Box, styled } from "@mui/material";
import { motion } from "framer-motion";
import pxToRem from "theme/base/pxToRem";

export const NavbarHeader = styled(Box)<{ isMiniSideNav: boolean }>(
  ({ theme, isMiniSideNav }) => ({
    transition: "all 0.3s ease-out",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: theme.spacing(1.5),
    marginLeft: isMiniSideNav ? theme.spacing(0.6) : 0,
    marginBottom: theme.spacing(5),
  })
);

export const LogoWrapper = styled(Box)<{ isMiniSideNav: boolean }>(
  ({ isMiniSideNav }) => ({
    display: "flex",
    alignItems: "center",
    flexDirection: isMiniSideNav ? "column" : "row",
    gap: "10px",
  })
);

export const MiniMenuButton = styled(motion.div)(({ theme }) => ({
  padding: pxToRem(2),
  borderRadius: pxToRem(4),
  backgroundColor: theme.palette.colorsBase.blue_1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: pxToRem(26),
  width: pxToRem(26),
  cursor: "pointer",
  svg: {
    path: {
      fill: theme.palette.icon.icLight,
    },
  },
}));
